import React from "react";
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import { usePermitsByUseType } from "../hooks/usePermitsByUseType";
import PieChart from "../charts/PieChart";
import { generateCSV } from "../utils";

const PermitsByUseTypeChart = () => {
  const {
    data,
    labels,
    chartData,
    isLoading,
    error,
    fiscalYears,
    selectedYear,
    setSelectedYear,
    aquiferGroups,
    selectedAquifer,
    setSelectedAquifer,
    chartType,
    setChartType,
    chartTitle,
  } = usePermitsByUseType();

  const controls = (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs>
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="use-type-chart-type-label">Chart Type</InputLabel>
          <Select
            labelId="use-type-chart-type-label"
            value={chartType}
            onChange={(e) => setChartType(e.target.value)}
            label="Chart Type"
          >
            <MenuItem value="permitted">Permitted Gallons</MenuItem>
            <MenuItem value="produced">Produced Gallons</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs>
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="use-type-year-label">Fiscal Year</InputLabel>
          <Select
            labelId="use-type-year-label"
            value={selectedYear || ""}
            onChange={(e) => setSelectedYear(e.target.value)}
            label="Fiscal Year"
          >
            {fiscalYears.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs>
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="use-type-aquifer-label">Aquifer</InputLabel>
          <Select
            labelId="use-type-aquifer-label"
            value={selectedAquifer}
            onChange={(e) => setSelectedAquifer(e.target.value)}
            label="Aquifer"
          >
            <MenuItem value="all">All Aquifers</MenuItem>
            {aquiferGroups.map(([ndx, name]) => (
              <MenuItem key={ndx} value={ndx}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );

  const handleDownloadCSV = () => {
    generateCSV(
      ["Use Type", "Total Gallons"],
      data.map((item) => [item.well_use_name, item.total_gallons])
    );
  };

  return (
    <PieChart
      title={chartTitle}
      data={chartData}
      labels={labels}
      isLoading={isLoading}
      error={error}
      controls={controls}
      onDownloadCSV={handleDownloadCSV}
    />
  );
};

export default PermitsByUseTypeChart;
